import aquariskImage from './images/aquarisk.png';
import betasmartzImage from './images/betasmartz.png';
import blacklightImage from './images/blacklight.png';
import buddybetImage from './images/buddybet.png';
import linguaphoneImage from './images/linguaphone.png';
import llanosecoImage from './images/llanoseco.gif';
import macauImage from './images/macau_news.png';
import pesposaImage from './images/pesposa.png';
import pingusenglishImage from './images/pingusenglish.png';
import spindalImage from './images/spindal.png';
import upworkImage from './images/upwork.png';
import vandsImage from './images/vands.jpg';
import wisenseImage from './images/wisense.png';
import witsbitsImage from './images/witsbits.png';

const createClient = (id, image, bg) => ({
  id,
  image,
  bg,
});

export const betasmartz = createClient('betasmartz', betasmartzImage, '#D1F2A5');
export const vands = createClient('vands', vandsImage, '#000000');
export const pingusenglish = createClient('pingusenglish', pingusenglishImage, '#FFE052');
export const blacklight = createClient('blacklight', blacklightImage, '#000000');
export const witsbits = createClient('witsbits', witsbitsImage, '#4D5A5D');
export const spindal = createClient('spindal', spindalImage, '#851A52');
export const upwork = createClient('upwork', upworkImage, '#22E742');
export const llanoseco = createClient('llanoseco', llanosecoImage, '#F5ECCF');
export const buddybet = createClient('buddybet', buddybetImage, '#2A1514');
export const wisense = createClient('wisense', wisenseImage, '#F8F8FF');
export const linguaphone = createClient('linguaphone', linguaphoneImage, '#8B9DA7');
export const aquarisk = createClient('aquarisk', aquariskImage, '#1FF4DA');
export const pesposa = createClient('pesposa', pesposaImage, '#002147');
export const macauNews = createClient('macau-news', macauImage, '#4CD7B6');
// export const whatsongfm = createClient('whatsongfm', whatsongfmImage, '#F58A33');
// export const foo = createClient('foo', someImage, '#FF00FF');



// WEBPACK FOOTER //
// ./src/app/data/clients/index.js